<template>
    <div class="ui-list">
        <div class="inner">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ui-list',

}

</script>

<style lang="scss">
    .ui-list {
        margin: auto;
        padding: var(--padding-x2) 0;
        text-transform: lowercase;
        font-weight: bold;
        background: white;

        .inner > header {
            padding: 0 0 var(--padding-x2) 0;
            
            h2 {
                font-size: var(--title-size);
            }

            h3 {
                font-size: var(--base-size);
            }
            
            p {
                color: var(--gray);
                font-size: var(--title-size);

                a {
                    padding-left: var(--padding);
                    color: var(--yellow);

                    &:hover {
                        color: var(--font-color);
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 780px) {
       .ui-list .inner > header p a{
            padding-left: 1.2rem;
       }
       
       .ui-list {
            padding: var(--padding) 0;

            .inner > header {
                padding: 0 0 var(--padding) 0;
            }

            .cols {
                margin-left: var(--padding-50-neg);
                margin-right: var(--padding-50-neg);
            }

            .col-5-1,
            .col-4-1,
            .col-3-1 {
                width: 50%;
                padding: var(--padding-50);
            }
        }

    }
</style>